/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, errorCount: NonNullable<unknown> }} Activity_Embedding_Complete_With_ErrorsInputs */



/**
* | output |
* | --- |
* | "{name}: indexing finished with {errorCount} errors" |
*
* @param {Activity_Embedding_Complete_With_ErrorsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_embedding_complete_with_errors = /** @type {((inputs: Activity_Embedding_Complete_With_ErrorsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Embedding_Complete_With_ErrorsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name}: Indizierung abgeschlossen mit ${i?.errorCount} Fehlern`)
	return /** @type {LocalizedString} */ (`${i?.name}: indexing finished with ${i?.errorCount} errors`)
});